import { useState } from 'react'
import { useAsyncEffect } from '../../../__legacy__/components/platform/explore/common/utils'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import ArpRegistry from '../../arp-registry/ArpRegistry'
import { IUser } from '../../arp-registry/User'

const cache = new Map<number, IUser[]>()

export const useArpCollaborators = (media: IArpMedia) => {
  const [data, setData] = useState<IUser[]>([])
  const status = useAsyncEffect(async () => {
    const { subComponents, id } = media
    if (cache.has(id)) return setData(cache.get(id))
    if (subComponents.length === 0) return
    const subComponentMedia = subComponents.map((id) => ArpRegistry.cache.get(id.toString()))
    const users = subComponentMedia.map((m) => m.user)
    const secondLayerMediaIds = subComponentMedia.map((m) => m.subComponents).flat()
    if (secondLayerMediaIds.length !== 0) {
      const { media: secondLayerMedia } = await ArpRegistry.search({
        ids: secondLayerMediaIds,
        perPage: 10000
      })
      users.push(...secondLayerMedia.map((m) => m.user))
    }
    const filtered = users.filter(
      (user, index) =>
        index === users.findIndex((found) => found.walletAddress === user.walletAddress) &&
        user.walletAddress !== media.user.walletAddress
    )
    cache.set(id, filtered)
    setData(filtered)
  }, [media])
  return { status, data }
}
